import { BrainstormClearErrorsAction } from "./../../store/action/BrainstormActions";
import { TrainingClearErrorsAction } from "./../../store/action/TrainingActions";
import { SurveyClearErrorsAction } from "./../../store/action/SurveyActions";
import { Subscription } from "rxjs";
import { Component } from "@angular/core";
import { DatePipe } from "@angular/common";
import {
  IonicPage,
  NavController,
  NavParams,
  ToastController,
  Loading,
} from "ionic-angular";
import { SurveyAccomplishPage } from "../survey-accomplish/survey-accomplish";
import { Survey } from "./../../model/SurveyModel";
import { Store } from "@ngrx/store";
import { AppStore } from "../../store/AppStore";
import { LoginPage } from "../login/login";
import { ClearNotificationsAction } from "../../store/action/NotificationActions";
import { LogoutAction } from "../../store/action/UserActions";

import { CronosClearErrorsAction } from "../../store/action/CronosActions";

import { SurveyService } from "../../services/SurveyService";

import _ from "lodash";

@IonicPage()
@Component({
  selector: "page-survey",
  templateUrl: "survey.html",
  providers: [DatePipe],
})
export class SurveyPage {
  public icons: string[];
  public filteredItems: Array<Survey> = [];
  public userSurveys: Array<Survey> = [];
  public searchInput: string = null;
  public shouldShowCancelSearch: boolean = false;
  public selectedType: string = "1";
  public isLoading: boolean;
  public loader: Loading;

  private userSubscription: Subscription;
  private surveySubscription: Subscription;

  private userId: number;
  private loggingOff: boolean;

  private clickedSurveyId: number;
  private clickedSurveyType: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private store: Store<AppStore>,
    private toastCtrl: ToastController,
    private surveyService: SurveyService
  ) {
    this.loggingOff = false;
    if (this.navParams.get("surveyId")) {
      this.clickedSurveyId = this.navParams.get("surveyId");
    }
    if (this.navParams.get("surveyType")) {
      this.clickedSurveyType = this.navParams.get("surveyType");
      if (this.clickedSurveyType == "team") {
        this.selectedType = "2";
      }
    }
  }

  logoff() {
    this.presentToast("Acesso expirado. Efetue login novamente. (9)");
    localStorage.removeItem("expirationDate");
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new CronosClearErrorsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  ionViewWillEnter() {
    this.isLoading = false;

    this.userSubscription = this.store
      .select("userState")
      .subscribe((userState) => {
        if (userState.expired == true && !this.loggingOff) {
          this.loggingOff = true;
          this.logoff();
        }
        if (userState.user != null) {
          this.userId = userState.user.id;
          this.getUserSurveys(this.userId);
        }
      });
  }

  private getUserSurveys(userId: number) {
    this.surveyService.listUserSurveys(userId).subscribe((data) => {
      this.setUserSurveys(data);
    });
  }

  private setUserSurveys(data: any) {
    this.filteredItems = _.map(data || [], (item) => {
      item.dateApplied = this.formatDate(item.dateApplied);
      item.deadline = this.formatDate(item.deadline);
      item.startDate = this.formatDate(item.startDate);
      item.endDate = this.formatDate(item.endDate);
      return item;
    });
    this.userSurveys = this.filteredItems;
  }

  private formatDate(date: any) {
    if (!date) return null;

    if (date.indexOf("-") != -1) return new Date(date);

    date = date.split("/");
    date[2] =
      date[2].split(" ")[0].length == 2
        ? "20" + date[2].split(" ")[0]
        : date[2].split(" ")[0];
    return new Date(date[2], parseInt(date[1]) - 1, date[0]);
  }

  ionViewWillLeave() {
    if (this.userSubscription != null) this.userSubscription.unsubscribe();
    if (this.surveySubscription != null) this.surveySubscription.unsubscribe();
  }

  getColor(status: number) {
    switch (status) {
      case 0:
        return "disabled";
      case 1:
        return "primary";
      case 2:
        return "secondary";
      case 3:
        return "danger";
      default:
        return "";
    }
  }

  getDescription(status: number) {
    switch (status) {
      case 0:
        return "Não Iniciado";
      case 1:
        return "Em Andamento";
      case 2:
        return "Concluído";
      case 3:
        return "Expirado";
      default:
        return "";
    }
  }

  accomplishSurvey(event, mySurvey: Survey) {
    if (mySurvey.status == 0) {
      this.startSurvey(mySurvey);
      return;
    }
    this.callAccomplishSurvey(mySurvey);
  }

  private startSurvey(mySurvey: Survey) {
    this.surveyService.startSurvey(mySurvey.id).subscribe((userSurvey) => {
      if (userSurvey) {
        mySurvey = _.assign(mySurvey, {
          status: userSurvey.status,
          startDate: userSurvey.startDate,
        });
        this.callAccomplishSurvey(mySurvey);
      }
    });
  }

  private callAccomplishSurvey(mySurvey: Survey) {
    this.surveyService.findById(mySurvey.surveyId).subscribe((data) => {
      mySurvey.pesquisa = data || {};
      this.navCtrl.push(SurveyAccomplishPage, {
        item: mySurvey,
        type: this.selectedType,
      });
    });
  }

  changeList(e) {
    this.filteredItems = this.userSurveys;
  }

  search(e) {
    this.shouldShowCancelSearch = true;
    this.filteredItems = this.userSurveys.filter(
      (x) => x.survey.indexOf(this.searchInput) >= 0
    );
  }

  cancelSearch(e) {
    this.searchInput = "";
    this.shouldShowCancelSearch = false;
    this.filteredItems = this.userSurveys;
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "top",
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/survey/survey.ts